export default "__VITE_ASSET__C6Yl7FQI__"